<template>
  <div class="xc-step-wrap">
    <div class="xc-step-content">
      <div
        v-for="(step, index) in stepValue"
        :key="index"
        class="xc-step"
      >
        <div :class="step.active?(step.complete?'xc-step-default xc-step-complete':'xc-step-default xc-step-active'):'xc-step-default'">
          {{step.text}}
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKBAMAAAByAqLJAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMA4eggKCTW28W6RrDe85MAAAAySURBVAjXY0ACLJJgymkbmKMtzNAewOC00YBBWhTEYQjcuAjIYWCV3i0MUhCmZgDXCQD0ywfjpS8jrwAAAABJRU5ErkJggg==" v-if="step.complete"/>
        </div>
        <div :class="step.active?(step.complete?'xc-line-default xc-line-complete':'xc-line-default xc-line-active'):'xc-line-default'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XcStep",
  props: {
    // 步骤文字
    stepValue: {
      type: Array,
      default: () => {
        return [
          {
            text: "步骤1",
            active: true,
            complete: true
          },
          {
            text: "步骤2",
            active: true,
            complete: false
          },
          {
            text: "步骤3",
            active: false,
            complete: false
          }
        ];
      }
    }
  },
  data() {
    return {};
  },
  watch: {},

  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
